<template>
  <div :class="{ 'has-feedback': appendIcon }" class="form-group">
    <label
      v-if="label"
      :for="inputId"
      :class="`col-sm-${+labelCols} ${!previewMode && 'control-label'}`"
      >{{ label }}</label
    >
    <div :class="label ? `col-sm-${12 - +labelCols}` : ''">
      <div>
        <template v-if="!previewMode">
          <!--  :class="{ 'h-has-icon': tooltip }" -->
          <!-- <component :is="..."> didn't work when trying to update value externally for some reason -->
          <!-- Normally I would create BaseTextarea, but they would have identical code besides the tag -->
          <textarea
            v-if="textarea"
            v-bind="$attrs"
            :disabled="disabled"
            :class="{ 'has-error': error }"
            :value="value"
            :id="inputId"
            class="form-control"
            @input="$emit('input', $event.target.value)"
          />
          <input
            v-else
            v-bind="$attrs"
            :class="{ 'has-error': error }"
            :disabled="disabled"
            :value="value"
            :id="inputId"
            :type="type"
            class="form-control"
            @input="$emit('input', $event.target.value)"
          />
          <span
            v-if="appendIcon"
            :class="[{ clickable: !!onAppendIconClick }, `glyphicon-${appendIcon}`]"
            class="glyphicon form-control-feedback"
            aria-hidden="true"
            @click="onAppendIconClick"
          ></span>
          <!--        <i v-if="tooltip" v-tooltip.right="tooltip" class="icon-info"></i>-->
        </template>
        <template v-else>
          {{ value }}
        </template>
      </div>
      <div v-if="error" class="error-message">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'BaseInput',

  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    // It used to be needed - now it's not. Commenting it out to avoid unnecessary asset payloads.
    // tooltip: {
    //   type: String,
    //   default: '',
    // },
    id: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    labelCols: {
      type: [Number, String],
      default: 6,
    },
    appendIcon: {
      type: String,
      default: '',
    },
    onAppendIconClick: {
      type: Function,
      default: null,
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      inputId: '',
    };
  },

  created() {
    this.inputId = this.id || uuidv4();
  },
};
</script>

<style scoped>
.form-control-feedback {
  pointer-events: auto;
  height: 40px;
  line-height: 40px;
}
</style>
